import React, { useState } from 'react';
import {
  ArrowLeft,
  Banknote,
  ChevronRight,
  MapPin,
  ReceiptText,
  Tag,
  Zap
} from 'lucide-react';
import RestaurantOverlay from './RestaurantOverlay';
import { calculateSubtotal, formatMoney, getReadableAddress, isValidDeliveryLocation } from './restaurantUtils';

const UnsupportedRow = ({ icon: Icon, title }) => (
  <div className="rc-checkout-row is-disabled" aria-disabled="true">
    <Icon aria-hidden="true" />
    <div><strong>{title}</strong><p>Estamos trabajando en esta opción</p></div>
    <span>Próximamente</span>
  </div>
);

export default function RestaurantCheckout({
  cart,
  address,
  notes,
  submitting,
  error,
  onNotesChange,
  onAddress,
  onClose,
  onSubmit
}) {
  const [showInstructions, setShowInstructions] = useState(false);
  const subtotal = calculateSubtotal(cart);
  const validAddress = isValidDeliveryLocation(address);

  return (
    <RestaurantOverlay title="Finalizar pedido" onClose={onClose} className="rc-drawer rc-checkout">
      <header className="rc-drawer__heading">
        <button type="button" className="rc-mobile-back" onClick={onClose}><ArrowLeft aria-hidden="true" />Volver</button>
        <div><span className="rc-eyebrow">ÚLTIMO PASO</span><h2>Confirma tu pedido</h2><p>Revisa los datos antes de enviarlo.</p></div>
      </header>
      <div className="rc-drawer__content">
        <section className="rc-checkout-section">
          <h3>Método de pago</h3>
          <div className="rc-checkout-row is-selected">
            <Banknote aria-hidden="true" />
            <div><strong>Efectivo</strong><p>Pago al recibir el pedido</p></div>
            <span>Activo</span>
          </div>
          <UnsupportedRow icon={ReceiptText} title="Tarjeta o Deuna" />
        </section>

        <section className="rc-checkout-section">
          <h3>Datos de entrega</h3>
          <button type="button" className={`rc-checkout-row ${validAddress ? 'is-selected' : ''}`} onClick={onAddress}>
            <MapPin aria-hidden="true" />
            <div><strong>{getReadableAddress(address)}</strong><p>{address?.reference || 'Agrega una referencia para el repartidor'}</p></div>
            <ChevronRight aria-hidden="true" />
          </button>
          <button type="button" className="rc-checkout-row" onClick={() => setShowInstructions((value) => !value)}>
            <ReceiptText aria-hidden="true" />
            <div><strong>Instrucciones de entrega</strong><p>{notes || 'Añade una indicación opcional'}</p></div>
            <ChevronRight aria-hidden="true" />
          </button>
          {showInstructions && (
            <label className="rc-field rc-instructions">
              <span>¿Necesitas cambiar algo?</span>
              <textarea
                value={notes}
                onChange={(event) => onNotesChange(event.target.value.slice(0, 100))}
                maxLength={100}
                placeholder="Ej.: llamar al llegar"
              />
              <small>{notes.length}/100</small>
            </label>
          )}
        </section>

        <section className="rc-checkout-section">
          <h3>Opciones adicionales</h3>
          <UnsupportedRow icon={Tag} title="Cupón de descuento" />
          <UnsupportedRow icon={Zap} title="Envío prioritario" />
          <UnsupportedRow icon={ReceiptText} title="Datos de facturación" />
        </section>
        {error && <p className="rc-field-error" role="alert">{error}</p>}
      </div>
      <footer className="rc-drawer__footer">
        <div className="rc-summary-row"><span>Subtotal</span><strong>{formatMoney(subtotal)}</strong></div>
        <div className="rc-summary-row rc-summary-row--muted"><span>Envío y total final</span><span>Calculados por PROVI</span></div>
        <button type="button" className="rc-button rc-button--primary" disabled={submitting || !cart.length || !validAddress} onClick={onSubmit}>
          {submitting ? 'Confirmando pedido…' : 'Realizar pedido'}
        </button>
        {!validAddress && <p className="rc-checkout-hint">Selecciona una dirección válida para continuar.</p>}
      </footer>
    </RestaurantOverlay>
  );
}
